var _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 260",
    width: 800,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 260,
    rx: 16,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 200,
    rx: 12,
    fill: "#fff",
    stroke: "#e6edf3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 14,
    fill: "#2563eb",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#e6edf3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(230,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 200,
    rx: 12,
    fill: "#fff",
    stroke: "#e6edf3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 14,
    fill: "#2563eb",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#e6edf3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 200,
    rx: 12,
    fill: "#fff",
    stroke: "#e6edf3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 14,
    fill: "#2563eb",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#e6edf3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(610,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 200,
    rx: 12,
    fill: "#fff",
    stroke: "#e6edf3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 14,
    fill: "#2563eb",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#e6edf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.1f3c264154d7cdc2dc84418fd8362e28.svg";
export { ForwardRef as ReactComponent };